import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player';

export const VideoComponent = (props: any) => {

  const { id, element, itemOnClick, playIcon } = props;

  const [videoUrl, setVideoUrl] = useState('');
  const [time, setTime] = useState('');
  const [playing, setPlaying] = useState(false);
  const [thumbnailLink, setThumbnailLink] = useState('');

  const [ended, setEnded] = useState(false);
  const handlePlaying = () => {
  };
  useEffect(() => {
    const padTo2Digits = (num : any) => {
      return num.toString().padStart(2, '0');
    };

    const convertMsToHM = (milliseconds : any) => {
      let seconds = Math.floor(milliseconds / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);

      seconds = seconds % 60;
      // 👇️ if seconds are greater than 30, round minutes up (optional)
      minutes = seconds >= 30 ? minutes + 1 : minutes;

      minutes = minutes % 60;

      hours = hours % 24;

      if (hours > 0) {
        return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
      }
      return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
    };

    if (!videoUrl) {
      const video_id = `${element.webViewLink.split('d/')[1].split('/view')[0]}`;
      const video_url = `https://drive.google.com/uc?export=view&id=${video_id}`;
      const converted_time = convertMsToHM(
        element.videoMediaMetadata && element.videoMediaMetadata.durationMillis
          ? element.videoMediaMetadata.durationMillis
          : 0
      );
      setVideoUrl(video_url);
      setTime(converted_time);
      setThumbnailLink(element.thumbnailLink);
    }
  }, [element]);

  useEffect(() => {
    if (ended) {
      setPlaying(false);
      setEnded(false);
      setVideoUrl('');
      setThumbnailLink(element.thumbnailLink);
    }
  }, [ended]);

  useEffect(() => {
    const padTo2Digits = (num : any) => {
      return num.toString().padStart(2, '0');
    };

    const convertMsToHM = (milliseconds : any) => {
      let seconds = Math.floor(milliseconds / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);

      seconds = seconds % 60;
      // 👇️ if seconds are greater than 30, round minutes up (optional)
      minutes = seconds >= 30 ? minutes + 1 : minutes;

      minutes = minutes % 60;

      hours = hours % 24;

      if (hours > 0) {
        return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
      }
      return `${padTo2Digits(minutes)}:${padTo2Digits(seconds)}`;
    };

    if (!videoUrl) {
      const video_id = `${element.webViewLink.split('d/')[1].split('/view')[0]}`;
      const video_url = `https://drive.google.com/uc?export=view&id=${video_id}`;
      const converted_time = convertMsToHM(
        element.videoMediaMetadata && element.videoMediaMetadata.durationMillis
          ? element.videoMediaMetadata.durationMillis
          : 0
      );
      setVideoUrl(video_url);
      setTime(converted_time);
    }
  }, [videoUrl]);

  return (
    <div className="googleDriveApp-item" id={id}>
    <div
      className="googleDriveApp-abc"
      style={{
        width: '47%',
        height: '33%',
        minHeight: '150px',
        maxHeight: '150px',
        position: 'absolute',
        background: 'transparent',
        zIndex: 88,
      }}
      onClick={(e) => {
        itemOnClick(element);
      }}
    />
    {/*@ts-ignore*/}
    <ReactPlayer
    //@ts-ignore
      style={{ position: 'obsolute' }}
      url={videoUrl}
      width="100%"
      height="100%"
      playing={playing}
      onEnded={() => setEnded(true)}
      playIcon={
        <button
          style={{
            borderRadius: '10px',
            display: 'inline-flex',
            zIndex: 2,
            margin: '125px 96px 5px 5px',
            width: '70px',
            height: '20px',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            marginRight: 'auto',
            marginLeft: '5px',
            marginBottom: '5px',
            border: 'none',
            textAlign: 'end',
          }}
          onClick={handlePlaying}
          disabled={true}
        >
          <img
            src={playIcon}
            alt="close"
            width="16"
            style={{ marginTop: '1px', float: 'left', marginRight: '-7px', maxWidth: '100%', maxHeight: '148px' }}
          />
          <span className="googleDriveApp-span-img">{time}</span>
        </button>
      }
      light={thumbnailLink}
    />
  </div>
  )
}